<app-ferry-loading-screen [animated]="false"></app-ferry-loading-screen>
